import { unauthenticatedPagePromo } from '@gonfalon/dogfood-flags/dogfood-flags';
import { Message } from '@gonfalon/messages/Message';

import styles from '#components/ui/layout/InlineUnauthenticatedBanner.module.css';
import { UnauthenticatedPagePromos } from '#utils/unauthenticatedPage';

export const AgentControlBanner = () => {
  const activePromo = unauthenticatedPagePromo();

  if (activePromo !== UnauthenticatedPagePromos.agentControlLaunch2026) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <p className={styles.heading}>
        <Message id="login.agentControlBanner.heading" />
      </p>
      <p className={styles.description}>
        <Message id="login.agentControlBanner.body" />
      </p>
    </div>
  );
};
